module.exports = __webpack_public_path__ + "img/banner@3x.6f21d5a9.png";